import { fetcher } from '@commenda/utils';
import { CorporationType, Country } from '@prisma/client';
import { TAddressParams } from './updateBusinessEntity';

export interface CreateBusinessEntityParams {
  legalName: string;
  incorporationCountry: Country;
  corporationType: CorporationType;
  jurisdiction?: string | null;
  entityLegalFormId?: string;
  formationDate?: string;
  fiscalYearDay?: number;
  fiscalYearMonth?: number;
  governanceStructureCode?: string;
  isNonControlledEntity?: boolean;
  entityEmail?: string;
  uniqueIdentifierFromJurisdiction?: string;
  operatingAddress?: TAddressParams;
}

/** Answers 201 with `{ businessEntity: { id } }`. */
const createBusinessEntity = async (
  companyId: number,
  body: CreateBusinessEntityParams
) => {
  return fetcher('business-entities', {
    method: 'POST',
    body: { ...body, companyId },
  });
};

export { createBusinessEntity };
